import React from 'react';

import { useEmbeddedChatContext } from '../EmbeddedChatContext';

import { EmbeddedChatHeaderActions } from './EmbeddedChatHeaderActions';
import { EmbeddedChatHeaderBadge } from './EmbeddedChatHeaderBadge';
import { EmbeddedChatHeaderLogo } from './EmbeddedChatHeaderLogo';

interface EmbeddedChatHeaderProps {
  onClose: () => void;
}

export const EmbeddedChatHeader: React.FC<EmbeddedChatHeaderProps> = ({ onClose }) => {
  const { isSearchActive } = useEmbeddedChatContext();

  return (
    // We are hardcoding the height of the header to prevent UI jumps when moving between states
    <header className="flex min-h-[68px] items-center justify-between bg-white/50 px-20">
      {!isSearchActive && (
        <div className="flex items-center gap-8">
          <EmbeddedChatHeaderLogo />
          <EmbeddedChatHeaderBadge />
        </div>
      )}
      <EmbeddedChatHeaderActions onClose={onClose} />
    </header>
  );
};
